import { ALL_CHART_TYPES } from "constants/chart.constants";
import { createMergeWithDefaults } from "entities/utils";
import { RateCumChartRequestType, RateCumChartSettings } from "types";

import { BASE_RATE_CHART_SETTINGS, BASE_RATE_REQUEST } from "./baseRateRequest";

export const DEFAULT_RATE_CUM_CHART_SETTINGS: Partial<RateCumChartSettings> = {
  ...BASE_RATE_CHART_SETTINGS,
  chartType: ALL_CHART_TYPES.RateCum.id,
  pressureChartSettings: {
    product: "Oil",
    productivityIndex: false
  },
  totalFluidChartSettings: {
    product: "Total Fluid"
  }
};

export const DEFAULT_RATE_CUM_REQUEST: Partial<RateCumChartRequestType> = {
  ...BASE_RATE_REQUEST,
  chartSetting: DEFAULT_RATE_CUM_CHART_SETTINGS as RateCumChartSettings
};

export const generateRateCumRequestBody = createMergeWithDefaults(
  DEFAULT_RATE_CUM_REQUEST
);
